import { standard } from '@creditas-ui/themes';
import { pickIconsThemePropsHelper } from '@creditas-ui/utilities';
var globalIcons = standard.icons('globalIcons.size');
export var globalIconsProps = pickIconsThemePropsHelper(globalIcons, ['size', 'strokeWidth']);
export var globalIconsWrapperProps = pickIconsThemePropsHelper(globalIcons, ['width', 'height']);
//# sourceMappingURL=constants.js.map